import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { BannersComponent } from './components/banners/banners.component';
import { CardsComponent } from './components/cards/cards.component';
import { PromosComponent } from './components/promos/promos.component';
import { FooterComponent } from './components/footer/footer.component';
import { ShowPromoComponent } from './components/show-promo/show-promo.component';
import { MainComponent } from './components/main/main.component';
import { PromoComponent } from './components/promo/promo.component';
import { PromoscontainerComponent } from './components/promoscontainer/promoscontainer.component';
import { HttpClientModule } from '@angular/common/http';
import { DataServices } from './services/data.services';
import { BannersService } from './services/banners.service';
import { LoggingService } from './services/LoggingService.service';
import { LoginService } from './services/login.service';
import { CardsService } from './services/cards.service';
import { PromosService } from './services/promos.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ParamsService } from './services/params.service';
import { Mugan86GoogleAnalyticsModule } from 'mugan86-ng-google-analytics';
import { ShowContactComponent } from './components/show-contact/show-contact.component';
import { BannersHpComponent } from './components/banners-hp/banners-hp.component';
import { CardBannersComponent } from './components/card-banners/card-banners.component';
import { CardFilterComponent } from './components/card-filter/card-filter.component';
import { CardPromosComponent } from './components/card-promos/card-promos.component';
import {CategoriesService} from './services/categories.service';
import {FormsModule} from '@angular/forms';
import {StatesService} from './services/states.service';
import { NearPromosComponent } from './components/near-promos/near-promos.component';
import {AgmCoreModule} from '@agm/core';
import {NearByPromosService} from './services/nearbypromos.service';
import { CampPromosComponent } from './components/camp-promos/camp-promos.component';
import {CampaignsService} from './services/campaigns.service';
import { ShowPromoCampComponent } from './components/show-promo-camp/show-promo-camp.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    BannersComponent,
    CardsComponent,
    PromosComponent,
    FooterComponent,
    ShowPromoComponent,
    MainComponent,
    PromoComponent,
    PromoscontainerComponent,
    ShowContactComponent,
    BannersHpComponent,
    CardBannersComponent,
    CardFilterComponent,
    CardPromosComponent,
    NearPromosComponent,
    CampPromosComponent,
    ShowPromoCampComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    //NoopAnimationsModule,
    Mugan86GoogleAnalyticsModule.forRoot(
      {
        analyticsId: 'UA-173846099-1',
        showLog: false
      }
    ),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAqRFDHkVQ4lsIWsrpW55LEDVEQePKisVE',
      libraries: ['places']
    }),
    BrowserAnimationsModule,
    FormsModule
  ],

  providers: [LoggingService, LoginService, DataServices, BannersService, CardsService, PromosService, ParamsService, NgxSpinnerService, CategoriesService, StatesService, NearByPromosService, CampaignsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
